export default "__VITE_ASSET__BvLvrztE__"